import blog from "./blog"
import content from "./content"
import contests from "./contests"
import dashboard from "./dashboard"
import eightLeggedFreak from "./eightLeggedFreak"
import forum from "./forum"
import GET_OMDB_ID from "./getOmdbId"
import homeVideoReviews from "./homeVideoReviews"
import homeVideos from "./homeVideos"
import news from "./news"
import socials from "./socials"
import tmdb from "./tmdb"
import vendors from "./vendors"

export default {
  GET_OMDB_ID,
  blog,
  content,
  contests,
  dashboard,
  eightLeggedFreak,
  forum,
  homeVideoReviews,
  homeVideos,
  news,
  socials,
  tmdb,
  vendors
}
